import type { NormalisedError } from '/index';

interface ErrorSelectorState {
  error?: {
    errors?: NormalisedError[] | null;
  };
}

const getErrorsSelector = (state: ErrorSelectorState) => state.error?.errors ?? null;

export default getErrorsSelector;
